import { actionTypes } from "./actions";
const initialState = {};

const filterObject = (obj, filter, filterValue) =>
    Object.keys(obj).reduce(
        (acc, val) =>
            obj[val][filter] === filterValue
                ? {
                      ...acc,
                      [val]: obj[val],
                  }
                : acc,
        {}
    );

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.ORGANISATIONS_CLEAR: {
            return initialState;
        }
        case actionTypes.ORGANISATIONS_GET_SUCCESS: {
            const data = filterObject(action.payload, "isPrimary", true)[0];

            /** keeping this for reference for themes */
            // localStorage.setItem(
            //     "cvOrgConfig",
            //     JSON.stringify(data.organisation)
            // );
            return { ...data.organisation };
        }
        default: {
            return state;
        }
    }
}
